import { render, staticRenderFns } from "./ContentModal.vue?vue&type=template&id=581c58c8&"
import script from "./ContentModal.vue?vue&type=script&lang=js&"
export * from "./ContentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports